<template>
  <resource-edit-wrapper
    :title="$t('resources.alternative_contents.edit_alternative_content')"
    :need-modal="showModal"
    @saveAction="$refs['alternativeContentForm'].submit()">
    <AlternativeContentForm
      :alternativeContent="item"
      @isDirtyForm="isDirtyForm"
      ref="alternativeContentForm"
      @finishedSaving="finishedSaving" />
    <template #actions>
      <v-btn @click="cancel" class="ml-auto cancel__btn" color="primary" outlined>
        {{ $t("generic.buttons.cancel") }}
      </v-btn>
      <v-btn @click="save" :loading="saveLoading" color="primary">
        {{ $t("generic.buttons.save") }}
      </v-btn>
    </template>
  </resource-edit-wrapper>
</template>

<script>
  import ResourceEditWrapper from "@/components/resourceWrappers/ResourceEditWrapper";
  import AlternativeContentForm from "@/components/forms/AlternativeContentForm";
  import resourceCreateAndEditActions from "@/mixins/resourceCreateAndEditActions";

  export default {
    components: {
      ResourceEditWrapper,
      AlternativeContentForm,
    },
    mixins: [resourceCreateAndEditActions],
    props: {
      item: {
        type: Object,
        required: false,
        default() {
          return {};
        },
      },
    },
    data() {
      return {
        saveLoading: false,
      };
    },
    created() {
      this.$admin.toast.info(
        this.$t("generic.edit_warning.warning") + this.$t("generic.edit_warning.alternative_content"),
      );
    },
    methods: {
      save() {
        this.showModal = false;
        this.$refs["alternativeContentForm"].submit();
      },
      cancel() {
        this.$router.push({ name: "alternative_contents_list" });
      },
      finishedSaving() {
        this.saveLoading = false;
      },
    },
  };
</script>
